// extracted by mini-css-extract-plugin
export default {"resetPinContainer":"locked-pin_resetPinContainer__eWOgm","resetPin":"locked-pin_resetPin__J79uQ","lockedIcon":"locked-pin_lockedIcon__ECvhV"};